import { createSelector } from 'reselect';

import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';

import getDisplayableLocations from './getDisplayableLocations';

const { getEnabledSaleTypes } = OrderingSelectors;

const { SALE_TYPE } = OrderingConstants;

const saleTypesToIgnoreOnHomeScreen = [SALE_TYPE.CATERING_DELIVERY];

export default createSelector(
  [getDisplayableLocations, getEnabledSaleTypes],
  (displayableLocations, enabledSaleTypes) =>
    enabledSaleTypes.filter(
      saleType =>
        !saleTypesToIgnoreOnHomeScreen.includes(saleType) &&
        displayableLocations.some(location => location.supportedSaleTypes.includes(saleType)),
    ),
);
